import { useMutation, useQueryClient } from '@tanstack/react-query';
import config from '@/config';
import api from '@/shared/api';
import HandleHttpError from '@/shared/services/HandleHttpError';
import { useIntl } from 'react-intl';
import ToastrService from '@/shared/services/ToastrService';
import { IntraCompanyQueryKey } from './queryKey';
import { useStateService } from '@/shared/services/StateService';
import messages from '../messages';
const useBatchBill = () => {
    const queryClient = useQueryClient();
    const stateService = useStateService();
    const intl = useIntl();
    const { mutateAsync, isLoading } = useMutation(values => api.base
        .post(`${config.appUrls.api}/api/IntraCompany/BatchBill/`, values)
        .then(({ data }) => data), {
        onSuccess: (data) => {
            if (data) {
                queryClient.invalidateQueries([IntraCompanyQueryKey.Overview]);
                const onClick = data.id ? () => stateService.gotoJob(data.id) : undefined;
                ToastrService.info(intl.formatMessage(messages.BackgroundJobQueued), undefined, onClick);
            }
        },
        onError: e => {
            HandleHttpError(intl)(e);
        },
    });
    return { batchBill: mutateAsync, batchBillRunning: isLoading };
};
export default useBatchBill;
